var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'loader-wrap': true,
    'loader-wrap--active': _vm.active
  },attrs:{"data-wrapper":""}},[_c('div',{staticClass:"loader",attrs:{"data-loader":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }